import { useState } from 'react';

// Scalar mounts in /docs.html inside an <iframe> so its CSS is not
// clobbered by the SPA's Tailwind preflight. One iframe per API: the
// standalone bundle's multi-source config is unreliable, while the
// single-source `data-url` path is its documented happy path. docs.html
// builds each spec URL from the same VITE_* env; `?api=` only picks one.
const services = [
  { slug: 'accounts', title: 'Accounts' },
  { slug: 'kanban', title: 'Kanban' },
] as const;

function iframeSrc(slug: (typeof services)[number]['slug']): string {
  return `/docs.html?api=${slug}`;
}

export function DocsPage(): React.JSX.Element {
  const [activeSlug, setActiveSlug] = useState<(typeof services)[number]['slug']>('accounts');
  return (
    <main aria-label="API docs" className="flex h-screen w-screen flex-col">
      <nav
        aria-label="API selector"
        className="flex shrink-0 gap-2 border-b border-border bg-background px-4 py-2"
      >
        {services.map((s) => (
          <button
            key={s.slug}
            type="button"
            onClick={() => {
              setActiveSlug(s.slug);
            }}
            aria-pressed={s.slug === activeSlug}
            className={
              s.slug === activeSlug
                ? 'rounded bg-primary px-3 py-1.5 text-primary-foreground'
                : 'rounded px-3 py-1.5 text-foreground-default hover:bg-muted'
            }
          >
            {s.title}
          </button>
        ))}
      </nav>
      {/* Render every iframe up-front (display:none for inactive) so switching
          tabs doesn't re-fetch the spec. */}
      <div className="relative flex-1">
        {services.map((s) => (
          // eslint-disable-next-line react/iframe-missing-sandbox -- Scalar runs scripts and reads its own origin (localStorage, CORS fetches of the spec); the rule allows no sandbox value with both.
          <iframe
            key={s.slug}
            title={`${s.title} API docs`}
            src={iframeSrc(s.slug)}
            className={
              s.slug === activeSlug
                ? 'absolute inset-0 block h-full w-full border-0'
                : 'absolute inset-0 hidden h-full w-full border-0'
            }
          />
        ))}
      </div>
    </main>
  );
}
